// ---------------------------------------------------------------------------
// Expression Lab drawer state (W2 T5). One drawer, many entry points
// (inspector / chat card / manual) — strategy §8.5: entry points multiply,
// the surface stays singular.
// ---------------------------------------------------------------------------

export interface ExpressionLabApplyTarget {
  blockName: string
  scope: string
  name: string
}

export interface ExpressionLabRequest {
  expression?: string
  applyTarget?: ExpressionLabApplyTarget | null
  source?: 'inspector' | 'chat' | 'manual'
}

export interface ExpressionLabSlice {
  expressionLabOpen: boolean
  expressionLabRequest: ExpressionLabRequest | null
  openExpressionLab: (request?: ExpressionLabRequest) => void
  closeExpressionLab: () => void
}

type Set_ = (fn: (state: ExpressionLabSlice) => void) => void

export function createExpressionLabSlice(set: Set_): ExpressionLabSlice {
  return {
    expressionLabOpen: false,
    expressionLabRequest: null,
    openExpressionLab: (request) =>
      set((s) => {
        s.expressionLabRequest = request ?? null
        s.expressionLabOpen = true
      }),
    closeExpressionLab: () =>
      set((s) => {
        s.expressionLabOpen = false
      }),
  }
}
